import { companyService } from "../services/companies";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import { clearAllTables } from "../utils/ui_utils";
import { hideMenu } from "../shared.js";

export class CompanyController {
  constructor() {
    this.type = "company";
    this.companyNav = document.querySelector(".company_nav");
    this.companyTableWindow = document.querySelector(".company_table_window");
    this.updateWindow = document.querySelector(".update-company-window");
    this.form = document.querySelector(".upload-company");
    this.btnModal = document.querySelector(".table_modal-company");
    this.table = null; // Tabulator instance
  }

  async init(currBtn, currAcc) {
    this.updateUI(currBtn);
    this.currentUser = currAcc;
    console.log(currAcc, currBtn);

    if (currAcc.status === "admin") {
      await this.initAdminView(currAcc);
    } else if (currAcc.status === "std") {
      await this.initStandardView();
    }
  }

  async initAdminView(currAcc) {
    // Get companies from Supabase
    console.log("Loading companies for user:", currAcc);
    const result = await companyService.listCompanies();
    if (!result.success) {
      console.error("Failed to load companies:", result.error);
      this.showNotification(`Errore nel caricamento: ${result.error}`, "error");
      return;
    }

    console.log("Loaded companies:", result.data);
    // Setup the data table
    this.setupDataTable(result.data, true);
  }

  async initStandardView() {
    const result = await companyService.listCompanies();
    if (!result.success) {
      console.error("Failed to load companies:", result.error);
      return;
    }

    // Setup the data table (read-only)
    this.setupDataTable(result.data, false);
  }

  setupDataTable(data, isAdmin = false) {
    console.log("Setting up company data table with data:", data);

    // Clear existing table and add Bootstrap container
    this.companyTableWindow.innerHTML = `
      <div class="container-fluid p-0">
        <div class="row">
          <div class="col-12">
            <div class="card border-0">
              <div class="card-header" style="background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%); border: none; padding: 1.5rem;">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <div class="bg-white rounded-circle p-2 me-3" style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                      <img src="/icons/menu-company.jpg" alt="Company Icon" style="width: 35px; height: 35px; border-radius: 15px; object-fit: cover;">
                    </div>
                    <div>
                      <h5 class="card-title mb-0 text-white fw-bold">Gestione Aziende</h5>
                      <small class="text-white opacity-75"></small>
                    </div>
                  </div>
                  ${
                    isAdmin
                      ? `
                    <button class="btn btn-light add-company-btn shadow-sm" style="padding: 0.75rem 1.5rem; border-radius: 10px; font-weight: 500;">
                      <i class="bi bi-plus-circle me-2" style="color: #59a370;"></i>
                      <span style="color: #59a370;">Aggiungi Azienda</span>
                    </button>
                  `
                      : ""
                  }
                </div>
              </div>
              <div class="card-body p-0" style="border-radius: 0 0 15px 15px; overflow: hidden;">
                <div id="companies-table" style="width: 100%; min-height: 400px;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    // Add event listener for the new add button
    if (isAdmin) {
      const addBtn = this.companyTableWindow.querySelector(".add-company-btn");
      if (addBtn) {
        addBtn.addEventListener("click", () => this.handleAddCompany());
      }
    }

    // Add custom styles first
    this.addCustomStyles();

    // Define columns based on user role
    const columns = [
      // {
      //   title: "ID",
      //   field: "company_id",
      //   sorter: "string",
      //   width: 120,
      //   headerFilter: "input",
      // },
      {
        title: "Azienda",
        field: "company_name",
        sorter: "string",
        width: 250,
        headerFilter: "input",
      },
      {
        title: "Indirizzo",
        field: "street",
        sorter: "string",
        width: 200,
        formatter: (cell) => {
          const row = cell.getRow().getData();
          const parts = [];
          if (row.street) parts.push(row.street);
          if (row.city) parts.push(row.city);
          if (row.province) parts.push(row.province);
          return parts.join(", ") || "";
        },
      },
      {
        title: "Città",
        field: "city",
        sorter: "string",
        width: 150,
      },
      {
        title: "Telefono",
        field: "telephone",
        sorter: "string",
        width: 150,
        formatter: (cell) => {
          const phone = cell.getValue();
          return phone ? `<i class="bi bi-telephone me-1"></i>${phone}` : "";
        },
      },
    ];

    // Add action buttons for admin users
    if (isAdmin) {
      columns.push({
        title: "Azioni",
        field: "actions",
        width: 120,
        formatter: () => {
          return `
            <div class="btn-group" role="group">
              <button class="btn btn-outline-primary btn-sm btn-edit" title="Modifica">
                <i class="bi bi-pencil" style="pointer-events: none;"></i>
              </button>
              <button class="btn btn-outline-danger btn-sm btn-delete" title="Elimina">
                <i class="bi bi-trash" style="pointer-events: none;"></i>
              </button>
            </div>
          `;
        },
        cellClick: (e, cell) => {
          e.stopPropagation();
          const target = e.target.closest("button");
          if (!target) return;

          const rowData = cell.getRow().getData();

          if (target.classList.contains("btn-edit")) {
            this.handleUpdateCompany(rowData);
          } else if (target.classList.contains("btn-delete")) {
            this.handleDeleteCompany(rowData);
          }
        },
      });
    }

    console.log("Creating Tabulator with columns:", columns);

    // Wait a bit to ensure DOM is ready
    setTimeout(() => {
      try {
        // Initialize Tabulator
        this.table = new Tabulator("#companies-table", {
          data: data,
          columns: columns,
          layout: "fitColumns",
          responsiveLayout: "hide",
          pagination: "local",
          paginationSize: 15,
          paginationSizeSelector: [10, 15, 25, 50],
          movableColumns: true,
          resizableRows: true,
          tooltips: true,
          tooltipsHeader: true,
          initialSort: [{ column: "company_name", dir: "asc" }],
          placeholder: "Nessuna azienda trovata",
          langs: {
            it: {
              pagination: {
                page_size: "Righe per pagina",
                page_title: "Mostra pagina",
                first: "Prima",
                first_title: "Prima pagina",
                last: "Ultima",
                last_title: "Ultima pagina",
                prev: "Precedente",
                prev_title: "Pagina precedente",
                next: "Successiva",
                next_title: "Pagina successiva",
                all: "Tutte",
                counter: {
                  showing: "Mostrando",
                  of: "di",
                  rows: "righe",
                },
              },
              headerFilters: {
                default: "Filtra colonna...",
                columns: {
                  company_id: "Filtra per ID...",
                  company_name: "Filtra per azienda...",
                },
              },
            },
          },
          locale: "it",
          columnDefaults: {
            tooltip: true,
          },
        });

        console.log("Tabulator created successfully:", this.table);
      } catch (error) {
        console.error("Error creating Tabulator:", error);
        // Fallback to simple table
        this.createFallbackTable(data, columns);
      }
    }, 100);
  }

  createFallbackTable(data, columns) {
    console.log("Creating fallback table");

    let tableHTML = `
      <div style="border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden; background: white;">
        <table style="width: 100%; border-collapse: collapse;">
          <thead style="background-color: #f8fafc;">
            <tr>
    `;

    columns.forEach((col) => {
      tableHTML += `<th style="padding: 12px 8px; text-align: left; font-weight: 600; border-bottom: 2px solid #e5e7eb;">${col.title}</th>`;
    });

    tableHTML += `
            </tr>
          </thead>
          <tbody>
    `;

    data.forEach((row, index) => {
      const bgColor = index % 2 === 0 ? "#ffffff" : "#f9fafb";
      tableHTML += `<tr style="background-color: ${bgColor};">`;

      columns.forEach((col) => {
        if (col.field === "actions") {
          tableHTML += `
            <td style="padding: 8px; border-bottom: 1px solid #f3f4f6; text-align: center;">
              <button onclick="window.companyController.handleUpdateCompany(${JSON.stringify(
                row
              ).replace(/"/g, "&quot;")})" 
                      style="background: none; border: none; color: #3b82f6; cursor: pointer; margin-right: 8px;">
                ✏️
              </button>
              <button onclick="window.companyController.handleDeleteCompany(${JSON.stringify(
                row
              ).replace(/"/g, "&quot;")})" 
                      style="background: none; border: none; color: #ef4444; cursor: pointer;">
                🗑️
              </button>
            </td>
          `;
        } else {
          let value = row[col.field] || "";
          if (col.field === "street") {
            // Handle address formatting for the street column
            const parts = [];
            if (row.street) parts.push(row.street);
            if (row.city) parts.push(row.city);
            if (row.province) parts.push(row.province);
            value = parts.join(", ") || "";
          } else if (col.field === "telephone" && value) {
            value = `📞 ${value}`;
          }
          tableHTML += `<td style="padding: 8px; border-bottom: 1px solid #f3f4f6;">${value}</td>`;
        }
      });

      tableHTML += `</tr>`;
    });

    tableHTML += `
          </tbody>
        </table>
      </div>
    `;

    this.companyTableWindow.innerHTML = tableHTML;

    // Make controller available globally for fallback buttons
    window.companyController = this;
  }

  addCustomStyles() {
    if (document.getElementById("company-table-styles")) return;

    const style = document.createElement("style");
    style.id = "company-table-styles";
    style.textContent = `
      /* Tabulator base styling for companies */
      .tabulator {
        border: none !important;
        border-radius: 0 !important;
        font-family: 'Poppins', sans-serif !important;
        font-size: 14px !important;
        background-color: white !important;
        overflow: hidden !important;
      }
      
      /* Header styling */
      .tabulator .tabulator-header {
        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
        border-bottom: 2px solid #59a370 !important;
      }
      
      .tabulator .tabulator-header .tabulator-col {
        background: transparent !important;
        border-right: 1px solid #e5e7eb !important;
        padding: 15px 12px !important;
      }
      
      .tabulator .tabulator-header .tabulator-col .tabulator-col-content {
        padding: 0 !important;
      }
      
      .tabulator .tabulator-header .tabulator-col .tabulator-col-title {
        font-weight: 600 !important;
        color: #59a370 !important;
        font-size: 13px !important;
        text-transform: uppercase !important;
        letter-spacing: 0.5px !important;
      }
      
      .tabulator .tabulator-header .tabulator-col.tabulator-sortable:hover {
        background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%) !important;
      }
      
      .tabulator .tabulator-header .tabulator-col.tabulator-sortable:hover .tabulator-col-title {
        color: white !important;
      }
      
      /* Row styling */
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row {
        border-bottom: 1px solid #f1f5f9 !important;
        min-height: 50px !important;
        transition: all 0.2s ease !important;
      }
      
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row:hover {
        background: linear-gradient(135deg, #f0f9f4 0%, #ecfdf5 100%) !important;
        box-shadow: 0 2px 4px rgba(89, 163, 112, 0.1) !important;
      }
      
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row.tabulator-row-even {
        background-color: #ffffff !important;
      }
      
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row.tabulator-row-odd {
        background-color: #fafbfc !important;
      }
      
      /* Cell styling */
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row .tabulator-cell {
        border-right: 1px solid #f3f4f6 !important;
        padding: 12px !important;
        vertical-align: middle !important;
        font-weight: 500 !important;
      }
      
      /* Filter styling */
      .tabulator .tabulator-header .tabulator-col .tabulator-header-filter input {
        border: 2px solid #e5e7eb !important;
        border-radius: 8px !important;
        padding: 6px 12px !important;
        font-size: 12px !important;
        width: 100% !important;
        box-sizing: border-box !important;
        transition: all 0.3s ease !important;
        font-family: 'Poppins', sans-serif !important;
      }
      
      .tabulator .tabulator-header .tabulator-col .tabulator-header-filter input:focus {
        outline: none !important;
        border-color: #59a370 !important;
        box-shadow: 0 0 0 3px rgba(89, 163, 112, 0.1) !important;
        background-color: #f8fafc !important;
      }
      
      /* Pagination styling */
      .tabulator .tabulator-footer {
        border-top: 2px solid #e5e7eb !important;
        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
        padding: 15px 20px !important;
        border-radius: 0 0 15px 15px !important;
      }
      
      .tabulator .tabulator-footer .tabulator-page {
        background-color: white !important;
        border: 2px solid #e5e7eb !important;
        color: #59a370 !important;
        margin: 0 3px !important;
        padding: 8px 12px !important;
        border-radius: 8px !important;
        font-weight: 500 !important;
        transition: all 0.2s ease !important;
      }
      
      .tabulator .tabulator-footer .tabulator-page.active {
        background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%) !important;
        color: white !important;
        border-color: #59a370 !important;
        box-shadow: 0 2px 4px rgba(89, 163, 112, 0.2) !important;
      }
      
      .tabulator .tabulator-footer .tabulator-page:hover:not(.active) {
        background-color: #f0f9f4 !important;
        border-color: #59a370 !important;
        transform: translateY(-1px) !important;
      }
      
      /* Bootstrap button group styling for actions */
      .btn-group .btn {
        margin: 0 !important;
        border-radius: 6px !important;
        transition: all 0.2s ease !important;
      }
      
      .btn-group .btn-outline-primary {
        border-color: #59a370 !important;
        color: #59a370 !important;
      }
      
      .btn-group .btn-outline-primary:hover {
        background-color: #59a370 !important;
        border-color: #59a370 !important;
        transform: translateY(-1px) !important;
      }
      
      .btn-group .btn-outline-danger:hover {
        transform: translateY(-1px) !important;
      }
      
      /* Responsive adjustments */
      @media (max-width: 768px) {
        .tabulator {
          font-size: 12px !important;
        }
        
        .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row .tabulator-cell {
          padding: 8px 6px !important;
        }
        
        .btn-group .btn {
          padding: 4px 8px !important;
          font-size: 12px !important;
        }
        
        .tabulator .tabulator-header .tabulator-col {
          padding: 10px 8px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  handleAddCompany() {
    console.log("Adding new company");

    // Add Bootstrap modal classes to the update window
    this.updateWindow.classList.remove("hidden");
    this.updateWindow.classList.add("modal", "fade", "show");
    this.updateWindow.style.display = "block";
    this.updateWindow.style.backgroundColor = "rgba(0,0,0,0.5)";

    // Update the modal content with Bootstrap structure
    this.form.innerHTML = `
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body p-5">
            ${this.createBootstrapFormMarkup()}
          </div>
        </div>
      </div>
    `;

    // Handle form submission
    const uploadBtn = this.form.querySelector(".uploadCompany__btn");
    const cancelBtn = this.form.querySelector('[data-bs-dismiss="modal"]');

    uploadBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      await this.submitNewCompany();
    });

    cancelBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeModal();
    });
  }

  async handleUpdateCompany(companyData) {
    console.log("Updating company:", companyData);

    // Add Bootstrap modal classes to the update window
    this.updateWindow.classList.remove("hidden");
    this.updateWindow.classList.add("modal", "fade", "show");
    this.updateWindow.style.display = "block";
    this.updateWindow.style.backgroundColor = "rgba(0,0,0,0.5)";

    // Update the modal content with Bootstrap structure
    this.form.innerHTML = `
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body p-5">
            ${this.createBootstrapFormMarkup(true, companyData)}
          </div>
        </div>
      </div>
    `;

    // Handle form submission
    const uploadBtn = this.form.querySelector(".uploadCompany__btn");
    const cancelBtn = this.form.querySelector('[data-bs-dismiss="modal"]');

    uploadBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      await this.submitUpdateCompany(companyData.id);
    });

    cancelBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeModal();
    });
  }

  async handleDeleteCompany(companyData) {
    console.log("Deleting company:", companyData);

    // Create Bootstrap confirmation modal
    const confirmationHtml = `
      <div class="modal fade show" style="display: block; background-color: rgba(0,0,0,0.5);" id="deleteConfirmModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-danger text-white">
              <h5 class="modal-title">
                <i class="bi bi-exclamation-triangle me-2"></i>Conferma Eliminazione
              </h5>
            </div>
            <div class="modal-body">
              <p class="mb-3">Sei sicuro di voler eliminare l'azienda:</p>
              <div class="alert alert-warning">
                <strong><img src="/icons/menu-company.jpg" alt="Company Icon" style="width: 20px; height: 20px; border-radius: 10px; object-fit: cover; margin-right: 8px; vertical-align: middle;">${
                  companyData.company_name || companyData.company
                }</strong>
              </div>
              <p class="text-muted small">Questa azione non può essere annullata.</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" id="cancelDelete">
                <i class="bi bi-x-circle me-1"></i>Annulla
              </button>
              <button type="button" class="btn btn-danger" id="confirmDelete">
                <i class="bi bi-trash me-1"></i>Elimina
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    // Add modal to body
    const modalContainer = document.createElement("div");
    modalContainer.innerHTML = confirmationHtml;
    document.body.appendChild(modalContainer);

    const modal = modalContainer.querySelector("#deleteConfirmModal");
    const confirmBtn = modal.querySelector("#confirmDelete");
    const cancelBtn = modal.querySelector("#cancelDelete");

    // Handle confirmation
    confirmBtn.addEventListener("click", async () => {
      const result = await companyService.deleteCompany(companyData.id);
      if (result.success) {
        await this.refreshTable();
        this.showNotification("Azienda eliminata con successo", "success");
      } else {
        console.error("Failed to delete company:", result.error);
        const errorMessage =
          result.error || "Errore nell'eliminazione dell'azienda";
        this.showNotification(errorMessage, "error");
      }
      document.body.removeChild(modalContainer);
    });

    // Handle cancellation
    cancelBtn.addEventListener("click", () => {
      document.body.removeChild(modalContainer);
    });
  }

  async submitNewCompany() {
    const companyData = this.getCompanyDataFromForm();

    if (!this.validateCompanyData(companyData)) {
      this.showNotification("Compila tutti i campi obbligatori", "error");
      return;
    }

    // Check for duplicate company_name
    const checkResult = await companyService.existsCompanyByName(
      companyData.company_name
    );
    if (!checkResult.success) {
      this.showNotification("Errore nel controllo del nome azienda.", "error");
      return;
    }
    if (checkResult.exists) {
      this.showNotification("Esiste già un'azienda con questo nome.", "error");
      return;
    }

    console.log("Creating company:", companyData);
    const result = await companyService.createCompany(companyData);

    if (result.success) {
      this.closeModal();
      await this.refreshTable();
      this.showNotification("Azienda creata con successo", "success");
    } else {
      console.error("Failed to create company:", result.error);
      const errorMessage =
        result.error || "Errore nella creazione dell'azienda";
      this.showNotification(errorMessage, "error");
    }
  }

  async submitUpdateCompany(companyId) {
    const companyData = this.getCompanyDataFromForm();

    if (!this.validateCompanyData(companyData)) {
      this.showNotification("Compila tutti i campi obbligatori", "error");
      return;
    }

    console.log("Updating company:", companyId, companyData);
    const result = await companyService.updateCompany(companyId, companyData);

    if (result.success) {
      this.closeModal();
      await this.refreshTable();
      this.showNotification("Azienda aggiornata con successo", "success");
    } else {
      console.error("Failed to update company:", result.error);
      const errorMessage =
        result.error || "Errore nell'aggiornamento dell'azienda";
      this.showNotification(errorMessage, "error");
    }
  }

  getCompanyDataFromForm() {
    return {
      company_name: this.form
        .querySelector('[name="company_name"]')
        .value.trim(),
      street: this.form.querySelector('[name="street"]').value.trim(),
      city: this.form.querySelector('[name="city"]').value.trim(),
      province: this.form.querySelector('[name="province"]').value.trim(),
      country: this.form.querySelector('[name="country"]').value.trim() || "IT",
      telephone: this.form.querySelector('[name="phone"]').value.trim(),
    };
  }

  validateCompanyData(companyData) {
    return companyData.company_name && companyData.company_name.length > 0;
  }

  closeModal() {
    this.updateWindow.classList.add("hidden");
    this.updateWindow.classList.remove("modal", "fade", "show");
    this.updateWindow.style.display = "none";
    this.updateWindow.style.backgroundColor = "";
    this.form.innerHTML = "";
  }

  async refreshTable() {
    if (!this.table) return;

    const result = await companyService.listCompanies();
    if (result.success) {
      this.table.setData(result.data);
    }
  }

  showNotification(message, type = "info") {
    // Create Bootstrap toast notification
    const toastId = `toast-${Date.now()}`;
    const iconClass =
      type === "success"
        ? "bi-check-circle-fill"
        : type === "error"
        ? "bi-exclamation-triangle-fill"
        : "bi-info-circle-fill";

    // Use our app's green theme colors
    const bgClass =
      type === "success"
        ? "text-white"
        : type === "error"
        ? "text-white"
        : "text-white";

    const bgStyle =
      type === "success"
        ? "background: linear-gradient(135deg, #059669 0%, #047857 100%);"
        : type === "error"
        ? "background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);"
        : "background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%);";

    const toastHtml = `
      <div class="toast align-items-center ${bgClass} border-0 shadow-lg" role="alert" aria-live="assertive" aria-atomic="true" id="${toastId}" style="${bgStyle} border-radius: 12px;">
        <div class="d-flex">
          <div class="toast-body py-3 px-4" style="font-weight: 500; font-size: 14px;">
            <i class="${iconClass} me-2" style="font-size: 16px;"></i>${message}
          </div>
          <button type="button" class="btn-close btn-close-white me-3 my-auto" data-bs-dismiss="toast" aria-label="Close" style="filter: brightness(0) invert(1);"></button>
        </div>
      </div>
    `;

    // Create or get toast container
    let toastContainer = document.querySelector(
      ".toast-container.fertify-notifications"
    );
    if (!toastContainer) {
      toastContainer = document.createElement("div");
      toastContainer.className =
        "toast-container fertify-notifications position-fixed top-0 end-0 p-3";
      toastContainer.style.zIndex = "9999";
      toastContainer.style.marginTop = "80px"; // Account for navbar height
      document.body.appendChild(toastContainer);
    }

    // Add toast to container
    const toastElement = document.createElement("div");
    toastElement.innerHTML = toastHtml;
    toastContainer.appendChild(toastElement.firstElementChild);

    // Initialize and show Bootstrap toast
    const toast = new bootstrap.Toast(document.getElementById(toastId), {
      autohide: true,
      delay: 5000,
    });

    toast.show();

    // Add custom animation styles
    const toastEl = document.getElementById(toastId);
    toastEl.style.transform = "translateX(100%)";
    toastEl.style.transition = "transform 0.3s ease-out";

    // Animate in
    setTimeout(() => {
      toastEl.style.transform = "translateX(0)";
    }, 10);

    // Remove toast element after it's hidden
    toastEl.addEventListener("hidden.bs.toast", () => {
      toastEl.style.transform = "translateX(100%)";
      setTimeout(() => {
        if (toastEl && toastEl.parentNode) {
          toastEl.remove();
        }
      }, 300);
    });
  }

  updateUI(currBtn) {
    // Clear active states and set current button as active
    document.querySelectorAll(".menu__btn").forEach((btn) => {
      btn.classList.remove("menu__btn--active");
    });
    currBtn.classList.add("menu__btn--active");
    hideMenu();
    // Clear all table windows
    clearAllTables(false);
  }

  // Create Bootstrap-styled form markup
  createBootstrapFormMarkup(isEdit = false, companyData = null) {
    const title = isEdit ? "Modifica Azienda" : "Aggiungi Azienda";
    const buttonText = isEdit ? "Aggiorna" : "Salva";

    return `
      <div class="modal-header border-bottom-0 pb-3 mb-4" style="background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%); margin: -2rem -2rem 2rem -2rem; padding: 2rem; border-radius: 15px 15px 0 0;">
        <div class="d-flex align-items-center text-white">
          <div class="bg-white rounded-circle p-2 me-3" style="width: 50px; height: 50px; display: flex; align-items: center; justify-content: center;">
            <img src="/icons/menu-company.jpg" alt="Company Icon" style="width: 40px; height: 40px; border-radius: 20px; object-fit: cover;">
          </div>
          <div>
            <h4 class="modal-title mb-0 fw-bold">${title}</h4>
            <small class="opacity-75"></small>
          </div>
        </div>
      </div>
      
      <form class="needs-validation" novalidate>
        <div class="row g-4">
          <!-- Company Name -->
          <div class="col-12 mb-3">
            <label for="company_name" class="form-label fw-semibold fs-5" style="color: #59a370;">
              <img src="/icons/menu-company.jpg" alt="Company Icon" style="width: 20px; height: 20px; border-radius: 10px; object-fit: cover; margin-right: 8px; vertical-align: middle;">Nome Azienda
            </label>
            <input 
              type="text" 
              class="form-control form-control-lg" 
              id="company_name" 
              name="company_name" 
              placeholder="Inserisci il nome dell'azienda"
              value="${companyData?.company_name || ""}"
              style="border: 2px solid #e5e7eb; border-radius: 10px; padding: 1rem; font-size: 1.1rem;"
              required
            >
            <div class="invalid-feedback">
              Il nome dell'azienda è obbligatorio.
            </div>
          </div>

          <!-- Address Section -->
          <div class="col-12">
            <div class="bg-light p-3 rounded-3 mb-3" style="background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;">
              <h6 class="mb-0 fw-bold" style="color: #59a370;">
                <i class="bi bi-geo-alt me-2"></i>Indirizzo
              </h6>
              <small class="text-muted">Informazioni di localizzazione dell'azienda</small>
            </div>
          </div>

          <!-- Address Fields -->
          <div class="col-lg-8">
            <label for="street" class="form-label fw-semibold">
              <i class="bi bi-house me-1"></i>Via/Indirizzo
            </label>
            <input 
              type="text" 
              class="form-control form-control-lg" 
              id="street" 
              name="street" 
              placeholder="Via, numero civico"
              value="${companyData?.street || ""}"
              style="border: 2px solid #e5e7eb; border-radius: 10px;"
            >
          </div>

          <div class="col-lg-4">
            <label for="phone" class="form-label fw-semibold">
              <i class="bi bi-telephone me-1"></i>Telefono
            </label>
            <input 
              type="tel" 
              class="form-control form-control-lg" 
              id="phone" 
              name="phone" 
              placeholder="Numero di telefono"
              value="${companyData?.telephone || ""}"
              style="border: 2px solid #e5e7eb; border-radius: 10px;"
            >
          </div>

          <div class="col-lg-6">
            <label for="city" class="form-label fw-semibold">
              <i class="bi bi-geo me-1"></i>Città
            </label>
            <input 
              type="text" 
              class="form-control form-control-lg" 
              id="city" 
              name="city" 
              placeholder="Città"
              value="${companyData?.city || ""}"
              style="border: 2px solid #e5e7eb; border-radius: 10px;"
            >
          </div>

          <div class="col-lg-3">
            <label for="province" class="form-label fw-semibold">
              <i class="bi bi-map me-1"></i>Provincia
            </label>
            <input 
              type="text" 
              class="form-control form-control-lg" 
              id="province" 
              name="province" 
              placeholder="Prov."
              value="${companyData?.province || ""}"
              style="border: 2px solid #e5e7eb; border-radius: 10px;"
              maxlength="2"
            >
          </div>

          <div class="col-lg-3">
            <label for="country" class="form-label fw-semibold">
              <i class="bi bi-flag me-1"></i>Paese
            </label>
            <input 
              type="text" 
              class="form-control form-control-lg" 
              id="country" 
              name="country" 
              placeholder="Paese"
              value="${companyData?.country || "IT"}"
              style="border: 2px solid #e5e7eb; border-radius: 10px;"
              maxlength="2"
            >
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="modal-footer border-top pt-4 mt-5 d-flex justify-content-end gap-3">
          <button type="button" class="btn btn-outline-secondary btn-lg px-4" data-bs-dismiss="modal" style="border-radius: 10px;">
            <i class="bi bi-x-circle me-2"></i>Annulla
          </button>
          <button type="submit" class="btn btn-lg px-5 uploadCompany__btn" style="background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%); border: none; color: white; border-radius: 10px; font-weight: 500;">
            <i class="bi bi-check-circle me-2"></i>${buttonText}
          </button>
        </div>
      </form>
    `;
  }
}

// Create and export a singleton instance
export const companyController = new CompanyController();
